import Backbone from 'backbone';

import template from './negativeKeywordListVNext.pug';

export class NegativeKeywordListContextualAttributeViewVNext extends Backbone.View {
  initialize({
    i18n,
  }) {
    this.i18n = i18n;
    this.negativeKeywordList = '';
  }

  render({
    showDeliveryStatusPopup,
  }) {
    this.negativeKeywordList = this.i18n.getString('Negative_Keyword_List');
    this.$el.html(template({ negativeKeywordList: this.negativeKeywordList }));

    showDeliveryStatusPopup(this.el.outerHTML);
    return this;
  }
}
